import { render, staticRenderFns } from "./ViewSocialMediaLink.vue?vue&type=template&id=54e5e20a"
import script from "./ViewSocialMediaLink.vue?vue&type=script&lang=js"
export * from "./ViewSocialMediaLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports